import React from 'react';
import { BankAccountRadioProps } from '../utils';
import { SnapIcon } from '../../SnapIcon';

export default function AddButton({
  selected,
  replaceAccountButtonDisabled,
  displayError,
  onSelect,
}: {
  selected: boolean;
  replaceAccountButtonDisabled: boolean;
  displayError: boolean;
  onSelect: (option: BankAccountRadioProps) => void;
}): React.JSX.Element {
  return (
    <button
      disabled={replaceAccountButtonDisabled}
      onClick={(): void => {
        onSelect({
          type: 'add',
        });
      }}
      className={`flex flex-col items-center mt-4 mb-6 rounded-lg shadow 'bg-white border border-gray-200'
      ${selected ? 'bg-blue-100 border-2 border-blue-500' : {}}

     ${displayError && !selected ? 'border-2 border-red-500' : {}}
        `}
    >
      <div className={`w-full flex flex-row px-2 py-4`}>
        <div className='flex items-start space-x-2'>
          <SnapIcon size='md' icon='plus-solid' />
          <div className='font-medium mb-2'>Add bank account</div>
        </div>
      </div>
    </button>
  );
}
